import React from "react";
import { Box, Stack, Card, CardMedia, Typography } from "@mui/material";
import Lottie from "lottie-react";
import { TeamTestimonialsSlider } from "./TeamTestimonialsSlider";
import { motion } from "framer-motion";

import heroAnimation from "../../assets/team/team .json";
import gana from "../../assets/team/ganeswaran.jpg";
import joice from "../../assets/team/joice.jpg";
import roman from "../../assets/team/roman1.png";

const teamMembers = [
  { id: 1, name: "E. Ganeshwaram", title: "CEO and Founder", image: gana },
  { id: 2, name: "J Joice Peries", title: "General Manager", image: joice },
  { id: 3, name: "Roman Figurado", title: "Operation Manager", image: roman },
];

const OurTeamContent = () => {
  return (
    <Box
      sx={{
        bgcolor: "black",
        color: "white",
        overflow: "hidden",
        px: { xs: 2, md: 10 },
        py: 4,
      }}
    >
      {/* ================================================= */}
      {/* TEAM HERO SECTION WITH BLUE GLOW (ADDED ONLY THIS) */}
      {/* ================================================= */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          py: { xs: 6, md: 10 },
        }}
      >
        {/* Blue Glow Background (same as About Us) */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-20%",
            left: 0,
            background:
              "radial-gradient(50% 50% at 50% 0%, rgba(94,176,239,0.5) 0%, rgba(255,255,255,0) 100%)",
            zIndex: 0,
          }}
        />

        {/* ---------- Hero Content ---------- */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              maxWidth: "1400px",
              width: "100%",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              gap: 6,
              px: { xs: 2, md: 4 },
            }}
          >
            {/* Animation - Left */}
            <Box sx={{ width: { xs: "100%", md: "600px" } }}>
              <motion.div
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
              >
                <Lottie
                  animationData={heroAnimation}
                  loop
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </motion.div>
            </Box>

            {/* Text - Right */}
            <Box
              sx={{
                width: { xs: "100%", md: "650px" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  color: "#ffffffa1",
                  fontSize: { xs: 22, md: 36 },
                }}
              >
                Our Team
              </Typography>

              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 26, md: 54 },
                  lineHeight: { xs: 1.4, md: "62px" },
                  mt: 1,
                  background:
                    "linear-gradient(176deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                The People Behind the Product
              </Typography>

              <Typography
                sx={{
                  color: "white",
                  fontSize: { xs: 14, md: 22 },
                  lineHeight: { xs: 1.6, md: 1.5 },
                  mt: 3,
                }}
              >
                We're a passionate, remote-first team working together to build
                smarter financial solutions for everyone in Sri Lanka. At
                Rubaai, we believe great things happen when good people come
                together, no matter where they are.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ---------- Leadership Team ---------- */}
      <Typography
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          mt: 8,
          mb: 6,
          fontSize: { xs: 18, md: 36 },
        }}
      >
        Our leadership team
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          overflowX: { xs: "auto", md: "visible" },
          gap: 2.5,
          px: { xs: 1, md: 0 },
          scrollSnapType: { xs: "x mandatory", md: "none" },
          "&::-webkit-scrollbar": { display: "none" },
          justifyContent: { xs: "flex-start", md: "center", xl: "center" },
        }}
      >
        {teamMembers.map((member) => (
          <Card
            key={member.id}
            sx={{
              flex: { xs: "0 0 auto", md: "none" },
              width: 247,
              height: 331,
              scrollSnapAlign: { xs: "start", md: "none" },
              position: "relative",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <CardMedia
              component="img"
              image={member.image}
              alt={member.name}
              sx={{ height: "100%", objectFit: "cover" }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: 73,
                bgcolor: "rgba(0,0,0,0.8)",
                backdropFilter: "blur(2px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                px: 2,
              }}
            >
              <Typography
  sx={{
    fontWeight: 600,
    fontSize: 16,
    color: "white",
  }}
>
  {member.name}
</Typography>

<Typography
  sx={{
    fontWeight: 400,
    fontSize: 14,
    color: "white",
  }}
>
  {member.title}
</Typography>

            </Box>
          </Card>
        ))}
      </Box>

      {/* ---------- Testimonials Section ---------- */}
      <Stack spacing={1.5} sx={{ mt: 8 }} alignItems="center">
        <Typography
          sx={{
            color: { xs: "#9e9e9e", md: "#ffffffa1" },
            fontWeight: "bold",
            fontSize: { xs: 20, md: 36 },
          }}
        >
          Voices of Our Team
        </Typography>
        <Typography
          sx={{
            fontWeight: 300,
            textAlign: "center",
            px: { xs: 2.5, md: 0 },
            fontSize: { xs: 16, md: 24 },
            maxWidth: 800,
          }}
        >
          Real stories and perspectives from the people who make us <br />
          who we are.
        </Typography>
      </Stack>

      <TeamTestimonialsSlider />
    </Box>
  );
};

export default OurTeamContent;
